module.exports = __webpack_public_path__ + "2656ff6245b612e3281e0d3b5b18d07b.svg";